import PouchDB from 'pouchdb-browser';

var remoteDbUrl = 'http://jess.recipes:5984/recipes'

if (location.protocol === 'https:')
{
	remoteDbUrl = 'https://jess.recipes:6984/recipes'
}

export const db = new PouchDB(remoteDbUrl)
